import { Component, OnInit } from '@angular/core';
import { UrlData } from '../../../../model/url-data';
import { UNIT_BUDGET_SIGN_ITEM, UNIT_SIGNED_SIGN_FROM, UNIT_SIGNED_STATUS_FORM } from '../../../constant/unit-signed';
import { WaittingSignCountService } from 'src/app/shared/service/common/waitting-sign-count.service';
import { GetSignDataService, InputPramData } from 'src/app/shared/service/common/get-sign-data.service';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { MatomoTracker } from 'ngx-matomo';

@Component({
  selector: 'app-unit-signed',
  templateUrl: './unit-signed.component.html',
  styleUrls: ['./unit-signed.component.scss']
})
export class UnitSignedComponent implements OnInit {
  // 组件销毁时停止订阅
  destroy$ = new Subject();
  // 用于防抖
  timer = null;

  nzSpinning: boolean = false;
  msgSign = [...UNIT_SIGNED_SIGN_FROM];//项目管理签核 部级签核 概算审核
  dubgetSign = [...UNIT_BUDGET_SIGN_ITEM];//一般工程 专案工程
  itemStatus = [...UNIT_SIGNED_STATUS_FORM];// 待签核 已签核
  activeBtnFirst = "";
  activeBtnSecond = "";
  activeBtnThird = "";
  totallistItem = [];
  total: number;
  pageSize: number;
  listItem = [];

  // 签核状态:0是待签核,1是已签核
  status: number = 0;
  // 签核步骤:1是项目管理签核,2是部级签核,5是概算审核
  step: number;
  firstStep: number;//msgSign的num
  secondStep: number;//dubgetSign的num
  projectType: number;//工程分类:一般工程=0;专案工程=1
  // countStatusDataByProjectType = {};
  // 用户ID
  userid: string;

  url: UrlData = {
    name: "ApplyingUnit",
    value: "/invoicessigned/unitsignedconfig/unitsigned"
  }


  countTotal: number;
  countStatusData = {
    1: {
      waitting: 0,
      signed: 0
    },
    2: {
      waitting: 0,
      signed: 0
    }
  };
  countStatusDataByProjectType = {
    9: {
      0: {
        waitting: 0,
        signed: 0
      }
    },
    10: {
      1: {
        waitting: 0,
        signed: 0
      }
    }
  }

  // 项目管理的待签数量
  step1WaittingCount: number;
  // 部级签核的待签数量
  step2WaittingCount: number;
  // 概算签核--一般工程的待签数量
  step9WaittingCount: number;
  // 概算签核--专案工程的待签数量
  step10WaittingCount: number;

  originData: any[] = [];
  originData1: any;

  constructor(
    private waittingSignCountService: WaittingSignCountService,
    private getSignDataService: GetSignDataService,
    private message: NzMessageService,
    private translateService: TranslateService,
    private matomoTracker: MatomoTracker
  ) { }

  async ngOnInit(): Promise<void> {
    this.matomoTracker.trackPageView('單據簽核/申請單位簽核');
    this.userid = localStorage.getItem('userid');
    if (!!localStorage.getItem('unitSignActiveBtnFirst')) {
      this.activeBtnFirst = localStorage.getItem('unitSignActiveBtnFirst');
      this.activeBtnSecond = localStorage.getItem('unitSignActiveBtnSecond');
      this.activeBtnThird = localStorage.getItem('unitSignActiveBtnThird');
      this.step = Number(localStorage.getItem('unitSignStep'));
      this.projectType = Number(localStorage.getItem('unitSignProjectTypet'));
      this.status = Number(localStorage.getItem('unitSignStatus')) >= 0 ? Number(localStorage.getItem('unitSignStatus')) : this.itemStatus[0].num;
    }
    else {
      // 默认值
      this.activeBtnFirst = this.msgSign[0].text;
      this.activeBtnSecond = this.dubgetSign[0].text;
      this.activeBtnThird = this.itemStatus[0].text;
      this.status = this.itemStatus[0].num;
      localStorage.setItem('unitSignStatus', String(this.status));
      this.step = this.msgSign[0].num;
    }
    // 查询项目管理签核的待签数量
    this.step1WaittingCount = await this.waittingSignCountService.getStepWaittingCount(1);
    // 查询部级签核的待签数量
    this.step2WaittingCount = await this.waittingSignCountService.getStepWaittingCount(2);
    // 查询概算签核--一般工程的待签数量
    this.step9WaittingCount = await this.waittingSignCountService.getStepWaittingCount(9, 0);
    // 查询概算签核--专案工程的待签数量
    this.step10WaittingCount = await this.waittingSignCountService.getStepWaittingCount(10, 1);

    this.countStatusData[1]['waitting'] = this.step1WaittingCount;
    this.countStatusData[2]['waitting'] = this.step2WaittingCount;
    this.countStatusDataByProjectType[9][0]['waitting'] = this.step9WaittingCount;
    this.countStatusDataByProjectType[10][1]['waitting'] = this.step10WaittingCount;
    // 获取单据已签核数量和当前step status userid下的单据list
    let param = {
      "status": this.status,
      "emplid": this.userid,
      "signStep": this.step
    };
    this.url["btnName"] = this.status === 0 ? this.translateService.instant('Common.Review') : this.translateService.instant('Common.Check');
    if ([1, 2].includes(this.step)) {
      this.countStatusData[this.step]['signed'] = await this.getSignDataService.getStepStatusCount({ userid: this.userid, step: this.step, status: 1 });
      await this.getInitFindSignData(param);
    }
    else {
      this.countStatusDataByProjectType[this.step][this.projectType]['signed'] = await this.getSignDataService.getStepStatusCount({ userid: this.userid, step: this.step, status: 1, projectCategory: this.projectType });
      await this.getInitFindSignData(param, this.projectType);
    }
  }

  async getInitFindSignData(param: InputPramData, projectType?: number) {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(async () => {//使用箭头函数,this指向的是当前组件
      this.nzSpinning = true;
      // 调用服务获取单据
      if (projectType === undefined) {
        await this.getSignDataService.getSignData(param).then(res => {
          this.totallistItem = res.totallistItem;
          this.total = res.total;
          this.countStatusData[this.step] = Object.assign(this.countStatusData[this.step], res.countStatusData);
          this.listItem = res.listItem;
          this.pageSize = res.pageSize;
        }).catch(e => {
          this.message.create('error', `${this.translateService.instant('CommonMessageTip.queryFailed')}`);
          this.nzSpinning = false;
        });
      }
      else {
        this.projectType = projectType;
        await this.getSignDataService.getSignData(param, this.projectType).then(projectRes => {
          this.totallistItem = projectRes.totallistItem;
          this.total = projectRes.total;
          this.countStatusDataByProjectType[this.step][projectType] = Object.assign(this.countStatusDataByProjectType[this.step][projectType], projectRes.countStatusDataByProjectType[projectType]);
          this.listItem = projectRes.listItem;
          this.pageSize = projectRes.pageSize;
        }).catch(e => {
          this.message.create('error', `${this.translateService.instant('CommonMessageTip.queryFailed')}`);
          this.nzSpinning = false;
        });
      }
      this.nzSpinning = false;
    }, 1200);
  }

  // 项目管理签核 部级签核 预算签核
  async conditionFirstQuery(active: string, firstNum: number) {
    this.activeBtnFirst = active;
    this.activeBtnThird = !!this.activeBtnThird ? this.activeBtnThird : this.itemStatus[0].text;
    this.firstStep = firstNum;
    this.step = firstNum;
    let param = {
      "status": this.status,
      "emplid": this.userid,
      "signStep": this.step
    }
    if ([1, 2].includes(this.step)) {
      await this.getInitFindSignData(param);
      if (this.status == 0) {
        this.countStatusData[this.step]['signed'] = await this.getSignDataService.getStepStatusCount({ userid: this.userid, step: this.step, status: 1 });
      }
    }
    else {
      if ((!this.activeBtnSecond) || this.activeBtnSecond === "Common.GeneralEngineering") {
        this.projectType = this.secondStep = 0;
        this.activeBtnSecond = "Common.GeneralEngineering";
      }
      else {
        this.secondStep = 1;
      }
      this.step = param.signStep = this.firstStep + this.secondStep;
      await this.getInitFindSignData(param, this.projectType);
      if (this.status == 0) {
        this.countStatusDataByProjectType[this.step][this.projectType]['signed'] = await this.getSignDataService.getStepStatusCount({ userid: this.userid, step: this.step, status: 1, projectCategory: this.projectType });
      }
    }
    this.url["btnName"] = this.activeBtnThird === "Common.ToBeApproved" ? this.translateService.instant("Common.Review") : this.translateService.instant("Common.Check");

    localStorage.setItem('unitSignActiveBtnFirst', this.activeBtnFirst);
    localStorage.setItem('unitSignActiveBtnSecond', this.activeBtnSecond);
    localStorage.setItem('unitSignActiveBtnThird', this.activeBtnThird);
    localStorage.setItem('unitSignStep', String(this.step));
    localStorage.setItem('unitSignProjectTypet', String(this.projectType));
    localStorage.setItem('unitSignStatus', String(this.status));
  }

  // 一般工程 专案工程
  async conditionSecondQuery(active: string, secondNum: number) {
    this.activeBtnFirst = "ApplyingUnit.BudgetsApproval";
    this.activeBtnSecond = active;
    this.projectType = this.secondStep = secondNum;
    this.firstStep = this.msgSign[2].num;
    this.step = this.firstStep + this.secondStep;
    let param = {
      "status": this.status,
      "emplid": this.userid,
      "signStep": this.step
    }

    await this.getInitFindSignData(param, this.projectType);
    localStorage.setItem('unitSignActiveBtnFirst', this.activeBtnFirst);
    localStorage.setItem('unitSignActiveBtnSecond', this.activeBtnSecond);
    localStorage.setItem('unitSignActiveBtnThird', this.activeBtnThird);
    localStorage.setItem('unitSignStep', String(this.step));
    localStorage.setItem('unitSignProjectTypet', String(this.projectType));
    localStorage.setItem('unitSignStatus', String(this.status));
  }

  // 待签核 已签核
  async conditionThirdQuery(active: string, num: number) {
    this.activeBtnThird = active;
    this.status = num;
    if (this.activeBtnThird === "Common.ToBeApproved") {
      this.url["btnName"] = this.translateService.instant('Common.Review');
    } else {
      this.url["btnName"] = this.translateService.instant('Common.Check');
    }
    let param = {
      "status": this.status,
      "emplid": this.userid,
      "signStep": this.step
    };
    if (this.activeBtnFirst === 'ApplyingUnit.BudgetsApproval') {
      await this.getInitFindSignData(param, this.projectType);
    }
    else {
      await this.getInitFindSignData(param);
    }
    localStorage.setItem('unitSignActiveBtnThird', this.activeBtnThird);
    localStorage.setItem('unitSignStatus', String(this.status));
    localStorage.setItem('unitSignStep', String(this.step));
  }
  // 根据条件查询
  async submitEvent(event) {
    let body = event;
    body["emplid"] = this.userid;
    body["status"] = this.status;
    body["signStep"] = this.step;
    if (this.step > 2) {
      await this.getInitFindSignData(body, this.projectType);
    }
    else {
      await this.getInitFindSignData(body);
    }
  }
  pageIndexChange(event: number) {
    this.listItem = this.totallistItem.slice(this.pageSize * (event - 1), event * this.pageSize);
  }
}
